<template>
  <DesltopSetting class="desktop-setting" @closeSettings="closeSettings"/>
  <div style="height: 100%" class="flex-column align-items-stretch flex-shrink-0 bg-body-tertiary chat-list-container" >
    <div class="d-flex align-items-center flex-shrink-0 p-3 link-body-emphasis text-decoration-none top-bar">
      <i class="fas fa-bars menu-icon"></i>
      <DesktopMenu @openSettings="openSettings" @logout="logout"/> <!-- Desktop Menu Popup Component -->
      <div class="logo-container">
        <img src="../assets/img/notica-persian.png" alt="Notica" class="img-fluid logo" width="100">
      </div>
      <div class="container">
        <div class="row justify-content-center">
          <div class="col-md-12">
            <div class="search-container">
              <input type="text" class="form-control search-input" placeholder="جستجو">
              <i class="fas fa-search search-icon"></i>
            </div>
          </div>
        </div>
      </div>
      <i class="fas fa-search search-icon-mobile"></i>
    </div>
    <div class="list-group list-group-flush border-bottom scrollarea">
      
        <a v-for="chat in chats" :key="chat.id" @click="selectChat(chat.id)" href="#" class="list-group-item list-group-item-action py-3 lh-sm chat" aria-current="true">
        <div class="d-flex w-100 align-items-center justify-content-between">
          <div class="d-flex align-items-center">
            <img class="rounded-circle border profile-img" width="50" :src="chat.logo" alt="">
            <div class="d-flex align-items-start flex-column ms-3">
              <span class="mb-1 company-name">{{ chat.name }}</span>
              <span class="desc">{{ getLastMessageSnippet(chat.id) }}</span>
            </div>
          </div>
          <div class="date-notif">
            <span v-if="getUnreadCount(chat.id) > 0" class="badge rounded-pill">
              {{ getUnreadCount(chat.id) }}
            </span>
            <small class="date">{{ getLastMessageDate(chat.id) }}</small>
          </div>
        </div>
      </a>
    </div>
    <div class="overlay" v-if="loading">
        <div class="loader">
            <div class="circle"></div>
        </div>
    </div>
  </div>
</template>

<script>
import DesktopMenu from '@/components/DesktopMenu.vue';
import DesltopSetting from '@/components/DesktopSetting.vue';
import axios from 'axios';
import Swal from 'sweetalert2';

export default {
  name: 'ChatList',
  props: {
    messages: Array
  },
  components: {
    DesktopMenu,
    DesltopSetting
  },
  mounted() {

    const chatItems = document.querySelectorAll('.chat');
    chatItems.forEach(item => {
      item.addEventListener('click', function() {
        chatItems.forEach(chat => chat.classList.remove('active'));
        this.classList.add('active');
      });
    });

    const menuIcon = document.querySelector('.menu-icon');
    menuIcon.addEventListener('click', function() {
      const menuContainer = document.querySelector('.menu-container');
      menuContainer.style.display = menuContainer.style.display === 'flex' ? 'none' : 'flex';
    });

    const searchIcon = document.querySelector('.search-icon-mobile');
    searchIcon.addEventListener('click', function() {
      if (window.innerWidth < 750) {
        const searchContainer = document.querySelector('.search-container');
        searchContainer.style.display = searchContainer.style.display === 'flex' ? 'none' : 'flex';
        const searchInput = document.querySelector('.search-input');
        searchInput.focus();
        const logoContainer = document.querySelector('.logo-container');
        logoContainer.style.display = logoContainer.style.display === 'none' ? 'flex' : 'none';
      }
    });
  },
  data() {
    return {
      chats: [],
      loading: false
    }
  },
  async beforeMount() {
    try {
      this.loading = true
      const token = localStorage.getItem('token');
      if (!token) {
        this.$router.push({ name: 'login' });
        return;
      }

      const response = await axios.get('https://api.noticapp.ir/v1/companies', {
        headers: {
          Authorization: `Bearer ${token}`,
        },
      });
      this.loading = false
      this.chats = response.data.data;

      

      if (response.data.status === 'error') {
        this.$router.push({ name: 'login' });
      }
    } catch (error) {
      if (error.response && error.response.status === 401) {
        this.$router.push({ name: 'login' });
      } else {
        console.error('خطای ناشناخنه رخ داده است: ', error);
      }
    }
    
  },
  methods: {
    getLastMessageDate(chatId) {
    // فیلتر کردن پیام‌ها برای چت خاص
      const filteredMessages = this.messages.filter(message => message.from === chatId);
      
      if (filteredMessages.length > 0) {
        const lastMessage = filteredMessages.reduce((latest, message) => {
          return new Date(latest.created_at) > new Date(message.created_at) ? latest : message;
        });
        
        // تبدیل تاریخ پیام به فرمت دلخواه
        const messageDate = new Date(lastMessage.created_at);
        const today = new Date();
        
        // مقایسه تاریخ پیام با تاریخ امروز
        if (messageDate.toDateString() === today.toDateString()) {
          // اگر پیام امروز است فقط ساعت را نمایش بده
          return messageDate.toLocaleTimeString([], { 
            hour: '2-digit', 
            minute: '2-digit', 
            hour12: false  // اطمینان از استفاده از فرمت 24 ساعته
          });
        } else {
          // اگر پیام مربوط به روزهای دیگر است، روز هفته و ساعت را نمایش بده
          return messageDate.toLocaleString('fa-IR', {
            weekday: 'long', // روز هفته
            hour: '2-digit', 
            minute: '2-digit', // ساعت و دقیقه
            hour12: false, // استفاده از فرمت 24 ساعته
          });
        }
      }
      return ''; // اگر پیام موجود نبود، چیزی نمایش داده نشود
    },
    getLastMessageSnippet(chatId) {
      // فیلتر کردن پیام‌ها برای چت خاص
      const filteredMessages = this.messages.filter(message => message.from === chatId);
      
      if (filteredMessages.length > 0) {
        const lastMessage = filteredMessages.reduce((latest, message) => {
          return new Date(latest.created_at) > new Date(message.created_at) ? latest : message;
        });

        // دریافت متن پیام و کوتاه کردن آن
        const messageText = lastMessage.message_text || ''; // فرض بر این است که متغیر text متن پیام را ذخیره می‌کند
        const maxLength = 30; // تعداد کاراکترهایی که می‌خواهید نشان داده شود
        
        // برش دادن متن پیام به تعداد کاراکترهای مشخص شده
        const snippet = messageText.length > maxLength ? messageText.substring(0, maxLength) + '...' : messageText;

        return snippet ? snippet.replace(/\/n/g, '') : '';
      }

      return ''; // اگر پیام موجود نبود، چیزی نمایش داده نشود
    },
    getUnreadCount(chatId) {
      // فیلتر کردن پیام‌ها برای چت خاص و پیام‌هایی که خوانده نشده‌اند
      const filteredMessages = this.messages.filter(message => message.from === chatId && !message.is_read);
      
      return filteredMessages.length; // تعداد پیام‌های خوانده نشده را برمی‌گرداند
    },
    selectChat(chatId) {
      const chat = this.chats.find(chat => chat.id === chatId);
      this.$emit('selectChat', chat);
    },
    openSettings() {
      const desktopSetting = document.querySelector('.desktop-setting');
      const chatList = document.querySelector('.chat-list-container');
      desktopSetting.style.display = 'flex';
      chatList.style.display = 'none';
      const menuContainer = document.querySelector('.menu-container');
      menuContainer.style.display = 'none';
    },
    closeSettings() {
      const desktopSetting = document.querySelector('.desktop-setting');
      const chatList = document.querySelector('.chat-list-container');
      desktopSetting.style.display = 'none';
      chatList.style.display = 'flex';
    },
    async logout() {
      Swal.fire({
        title: "خروج از حساب کاربری؟",
        text: "آیا مطمئن هستید که میخواهید خارج شوید؟",
        icon: "warning",
        showCancelButton: true,
        reverseButtons: true,
        confirmButtonColor: "#dc3741",
        cancelButtonColor: "#028D92",
        focusConfirm: false,
        showClass: {
          popup: `
          animate__animated
          animate__fadeInDown
          animate__faster
          `
        },
        hideClass: {
          popup: `
          animate__animated
          animate__fadeOutUp
          animate__faster
          `
        },
        iconColor: "red",
        confirmButtonText: "خروج!",
        cancelButtonText: "لغو",
        background: "#26292e",
        backdrop: "rgba(0, 0, 0, 0.8)",
        color: "white"
      }).then(async(result) => {
        if (result.isConfirmed) {
          try {
            const response = await axios.post('https://api.noticapp.ir/v1/auth/logout', {}, {
              headers: {
                Authorization: `Bearer ${localStorage.getItem('token')}`
              }
            });

            if (response.data.status === 'success') {
              localStorage.removeItem('token');
              this.$router.push('/login');
            }
          } catch (error) {
            console.error('خطا در خروج از حساب کاربری:', error);
          }
        }
      });
    }
  }
};
</script>

<style scoped>

.desktop-setting {
  width: 100%;
  display: none;
}

.chat-list-container {
  display: flex;
  width: 100%;
}
.chat-list {
  width: 400px;
}

.top-bar {
    background-color: #25292E;
    color: white;
    z-index: 10;
    box-shadow: 0 0 10px rgba(0, 0, 0, 0.25);
    height: 60px;
    display: flex;
    align-items: center;
    justify-content: space-between;
    padding: 0 15px;
}

.menu-icon {
    font-size: 30px;
    margin: 0 10px;
    color: white;
    cursor: pointer;
}

.scrollarea {
    height: calc(100vh - 60px);
    overflow-y: auto;
    overflow-x: hidden;
    background-color: #25292E;
    /* direction: ltr; */
    scroll-behavior: smooth;
}

.scrollarea::-webkit-scrollbar {
    width: 5px;
}

.scrollarea::-webkit-scrollbar-thumb {
    background-color: transparent;
    border-radius: 10px;
}

.scrollarea:hover::-webkit-scrollbar-thumb {
    background-color: #028D92;
}

.scrollarea::-webkit-scrollbar-track {
    background-color: transparent;
}

.scrollarea:hover::-webkit-scrollbar-track {
    background-color: #1B1E23;
}

.scrollarea::-webkit-scrollbar-thumb:hover {
    cursor: grab;
}

.chat {
    border: none;
    background-color: transparent;
    color: white;
    cursor: pointer;
    transition: all 0.3s;
    direction: rtl;
    
}

.chat:hover {
    background-color: #1B1E23;
}

.chat.active {
    background-color: #028D92 !important;
}

.badge {
    background-color: #c41b67;
}

.search-container {
    position: relative;
    display: flex;
}

.search-input {
    /* height: 50px; */
    border-radius: 15px;
    padding: 5px 20px;
    padding-right: 40px;
    border: none;
    color: #fff;
    box-shadow: 0 0 10px rgba(0, 0, 0, 0.1);
    background-color: #1B1E23;
}

.search-input:focus {
    outline: none;
    box-shadow: 0 0 10px rgba(0, 0, 0, 0.3);
    background-color: #1B1E23;
    color: #fff;
}

.search-input::placeholder {
    color: #888;
}

.search-icon {
    position: absolute;
    top: 50%;
    right: 15px;
    transform: translateY(-50%);
    color: #888;
}

.overlay {
        position: fixed;
        top: 0;
        left: 0;
        width: 100vw;
        height: 100vh;
        background-color: rgba(0, 0, 0, 0.8); /* پس‌زمینه نیمه‌شفاف */
        display: flex;
        justify-content: center;
        align-items: center;
        backdrop-filter: blur(5px); /* افکت مات */
        z-index: 1000; /* بالاتر از همه عناصر */
    }

    .loader {
        background: transparent;
        width: 80px;
        height: 80px;
        border-radius: 50%;
        position: relative;
        display: flex;
        justify-content: center;
        align-items: center;
    }

    .circle {
    width: 80px;
    height: 80px;
    border: 3px solid #028d92;
    position: absolute;
    border-radius: 50%;
    animation: circle14512 1.5s linear infinite;
    }

    .circle::before {
    content: '';
    position: absolute;
    top: -10px;
    left: 50%;
    transform: translateX(-50%);
    width: 20px;
    height: 20px;
    border-radius: 50%;
    background: #cc0066;
    box-shadow: 0 0 10px #cc0066, 0 0 20px #cc0066;
    }

    @keyframes circle14512 {
        0% {
            transform: rotate(0deg);
        }

        100% {
            transform: rotate(360deg);
        }
    }

.profile-img {
    margin: auto 0 auto 15px;
    border: none !important;
    border-radius: 50%;
    box-shadow: 0 0 10px rgba(0, 0, 0, 0.1);
    background-color: #1B1E23;
    width: 50px;
    height: 50px;
    object-fit: cover;
}

.company-name {
    font-size: 25px;
    font-weight: normal;
    color: #028D92;
}

.date-notif {
    display: flex;
    flex-direction: column;
    align-items: end;
    justify-content: flex-end;

}

.date {
    color: #888;
}

.active {
    background-color: #028D92 !important;
}
.active .company-name, .active .desc {
    color: #000;
}

.active .date {
    color: #000;
}

.search-icon-mobile {
    display: none;
}

.logo {
  display: none;
  max-height: 40px;
}

.logo-container {
  display: none;
  justify-content: center;
  align-items: center;
}

@media (max-width: 750px) {
    .search-container {
        display: none;
    }

    .search-icon-mobile {
        display: block;
        font-size: 30px;
        margin: 0 10px;
        color: white;
        cursor: pointer;
    }

    .top-bar {
        display: flex;
        justify-content: space-between;
    }

    .logo-container {
        display: flex;
    }

    .logo {
        display: block;
        margin: 0 auto;
    }

    
  }
</style>